import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { clearStoredSession } from "utils/userIdentity";

export default function LogoutHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;
    clearStoredSession()
      .catch(() => {})
      .finally(() => {
        if (isMounted) {
          navigate("/login");
        }
      });

    return () => {
      isMounted = false;
    };
  }, [navigate]);

  return null;
}
